import React from 'react'

import { View, StyleSheet, Linking, ScrollView, Platform } from 'react-native'

import { useClient, client } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, backgroundColors, typography } from '@sart/styles'
import { testID } from '@sart/utilities'
import { Button, Space, MenuList, Description } from '@sart/components'

const APPLE_INSTALL_LINK = 'https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=';


export default function ManageSubscription(props) {
  const content = useContent()

  const { navigation } = props

  const { cache } = useClient()

  const activated = client.cache.activated
  const activationCode = cache?.contextService?.primaryIdentifier
  const installLink = activationCode ? `${APPLE_INSTALL_LINK}${activationCode}` : ''

  async function handleLogout() {
    try {
      await client.signOutAndForget()
      navigation.popToTop()
      navigation.navigate('Sign', { screen: 'SignIn' })
    } catch (error) {
      console.log(error)
    }
  }

  function handleRouting(item) {
    if (item.link) {
      return Linking.openURL(item.link)
    }
    navigation.navigate(item.id)
  }

  const backToMenu = true
  async function changeLanguage(option) {
    await client.updateLanguage(client.cache.userId, option.value)

    navigation.setParams({ refreshed: true })
  }

  const menuItems = [
    // {id: 'Usage', label: 'Usage' },
    ...(activated ? [
      { id: 'ChangePlan', label: content.profile.changePlanLabel, },
      //{id: 'Settings', label: content.profile.settingsLabel, },
      { id: 'Switch', label: content.profile.switchLabel, },
      { id: 'SwitchPortOut', label: content.profile.portOutLabel, },
    ] : []),
    ...(Platform.OS === 'ios' && installLink ? [{ id: 'InstallEsim', label: content.profile.installEsimLabel, link: installLink }] : []),
    { id: 'CancelService', label: content.profile.cancelServiceLabel, },
  ]

  return (
    <ScrollView contentContainerStyle={styles.wrapper}>
      <View style={styles.widthRestrictions}>

        {!activated &&
          <>
            <Description style={[styles.description, { fontSize: 16 }]}>
              Please activate your subscription in order to view management options (e.g. Change Plan, Cancel Plan, Port-in, Request PAC)
            </Description>
            <Space height={24} />
          </>
        }

        {activated &&
          <>
            <MenuList color={colors.brightOrange}>
              {
                menuItems.map(item =>
                  <MenuList.Item
                    key={item.id}
                    label={item.label}
                    onPress={() => handleRouting(item)}
                    style={styles.menuListItemStyle}
                    {...testID(item.id)}
                  />
                )
              }
            </MenuList>
            <Space height={24} />
          </>
        }


        {/* TODO - removing this currently as we aren't supporting multiple languages for launch
        <Select
          label={content.menu.language}
          value={cache.language}
          icon={<LanguageIconType 
            type={cache.language}
            {...Platform.select({
              android: { style: styles.flagIcon }
            })}
          />}
          options={[
            { label: content.languages.en, value: 'en' },
            // { label: content.languages.es, value: 'es' }
          ]}
          onOptionChange={option => {
            changeLanguage(option)
          }}
          containerStyle={styles.selectStyle}
          labelStyle={styles.labelStyles}
          inputStyles={styles.inputStyles}
          injectedContent={content}
          {...testID('selectLanguage')}
        /> */}
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    ...adaptive.menuPaddingTop,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    backgroundColor: backgroundColors.darkCharcoal,
    width: '100%',
    alignItems: 'center'
  },
  selectStyle: {
    borderWidth: 1,
    // backgroundColor: backgroundColors.feature,
    color: colors.srGreen,
    borderColor: colors.srGreen,
    borderRadius: 4
  },
  logoutButtonStyle: {
    backgroundColor: colors.brightOrange
  },
  flagIcon: {
    alignSelf: 'center',
    position: 'absolute',
    right: '15%',
    bottom: '30%'
  },
  menuListItemStyle: {
    color: colors.white,
    ...typography.lightbold
  },
  labelStyles: {
    ...typography.demi
  },
  inputStyles: {
    ...typography.medium
  },
  spaceHeight: {
    ...adaptive.menuSpaceHeight
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
    marginLeft: 15,
    marginRight: 15,
    fontSize: 12,
  },
})
